/*global google*/
import React, { Component } from "react";
import {
    withGoogleMap,
    GoogleMap,
    Polyline
} from "react-google-maps";
class Map extends Component {
    state = {
        directions: null,
        quote:{},
};

    data = {};
    defaultMapOptions = {
        disableDefaultUI: true,
    };
    constructor(prop) {
        super(prop);
        this.state.quote = prop.quoteData;

    }

    componentDidMount() {
        this.setState({
            quote:  this.state.quote
        });

    }

    handleMapMounted = (map) => {
        if (map) {
            this.map = map.context['__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED'];
            const bounds = new window.google.maps.LatLngBounds();
            this.state.quote.route.overview_path.forEach((x) => {
                bounds.extend(new window.google.maps.LatLng(x.lat, x.lng));
            });
            const quote = this.state.quote;
                 new google.maps.Marker({
                map: this.map,
                title: quote.start,
                position: {lat: parseFloat(quote.start_lat), lng: parseFloat(quote.start_lng)},
            });
             new google.maps.Marker({
                map: this.map,
                title: quote.end,
                position: {lat: parseFloat(quote.end_lat), lng: parseFloat(quote.end_lng)},
            });
            // if(this.quote.one_way_via !== undefined && this.quote.one_way_via !== null){
            //     this.quote.one_way_via.forEach(function(ele){
            //         new google.maps.Marker({
            //             map: _this.map,
            //             title: ele.name,
            //             position: {lat: parseFloat(ele.lat), lng: parseFloat(ele.lng)},
            //             icon: _this.via_icon
            //         });
            //     });
            // }
            this.map.fitBounds(bounds)
        }
    };

render() {
    const GoogleMapExample = withGoogleMap(props => (
        <GoogleMap
            defaultCenter={{ lat: 6.5244, lng:  3.3792 }}
            defaultZoom={13}
            ref={props.onMapMounted}
            defaultOptions={this.defaultMapOptions}
        >
            <Polyline
                path={this.state.quote.route.overview_path}
                geodesic={true}
                options={{
                    strokeColor: "#ff2527",
                    strokeOpacity: 0.75,
                    strokeWeight: 2,
                }}
            />
        </GoogleMap>
    ));

    return (
        <div>
            <GoogleMapExample onMapMounted={this.handleMapMounted}
                containerElement={<div style={{ height: `300px`, width: "320px" }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
        </div>


       );
    }
}

export default Map;
